(() => {
  function formatMoney(cents, moneyFormat) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat || window.Shopify.money_format);
    }

    return `$${(Number(cents || 0) / 100).toFixed(2)}`;
  }

  class FrequentlyBoughtTogether extends HTMLElement {
    connectedCallback() {
      this.checkboxes = Array.from(this.querySelectorAll('[data-fbt-checkbox]'));
      this.totalNode = this.querySelector('[data-fbt-total]');
      this.addAllBtn = this.querySelector('[data-fbt-add-all]');
      this.moneyFormat = this.dataset.moneyFormat;

      if (!this.checkboxes.length || !this.totalNode || !this.addAllBtn) return;

      this.onChange = this.onChange.bind(this);
      this.onAddAll = this.onAddAll.bind(this);

      this.addEventListener('change', this.onChange);
      this.addAllBtn.addEventListener('click', this.onAddAll);

      this.recalculate();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      if (this.addAllBtn) this.addAllBtn.removeEventListener('click', this.onAddAll);
    }

    selectedItems() {
      return this.checkboxes
        .filter((checkbox) => checkbox.checked && !checkbox.disabled)
        .map((checkbox) => ({
          id: Number(checkbox.dataset.variantId),
          quantity: 1,
          price: Number(checkbox.dataset.price || 0)
        }))
        .filter((item) => item.id);
    }

    recalculate() {
      const items = this.selectedItems();
      const total = items.reduce((sum, item) => sum + item.price, 0);

      this.totalNode.textContent = formatMoney(total, this.moneyFormat);
      this.addAllBtn.textContent = `Add all ${items.length} to cart`;
      this.addAllBtn.disabled = items.length === 0;
    }

    onChange(event) {
      if (!event.target.matches('[data-fbt-checkbox]')) return;
      this.recalculate();
    }

    async onAddAll() {
      const items = this.selectedItems().map(({ id, quantity }) => ({ id, quantity }));
      if (!items.length) return;

      this.addAllBtn.disabled = true;

      try {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items,
            sections: sectionsToBundle.join(','),
            sections_url: window.location.pathname
          })
        });

        const responseJson = await response.json();
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

        if (!response.ok) throw new Error(responseJson?.description || 'Failed to add items');

        if (
          window.themeVariables?.settings?.cartType === 'page' ||
          window.themeVariables?.settings?.pageType === 'cart'
        ) {
          window.location.href = '/cart';
          return;
        }

        const cartContent = await (await fetch('/cart.js')).json();
        cartContent.sections = responseJson.sections;

        this.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            detail: {
              items: responseJson.items || [],
              cart: cartContent,
              onSuccessDo: null
            }
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              onSuccessDo: null,
              cart: cartContent
            }
          })
        );

        this.recalculate();
      } catch (error) {
        console.error('[fbt] failed to add items', error);
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        this.recalculate();
      } finally {
        this.addAllBtn.disabled = false;
      }
    }
  }

  if (!window.customElements.get('frequently-bought-together')) {
    window.customElements.define('frequently-bought-together', FrequentlyBoughtTogether);
  }
})();
